
import { IFile } from '@/utils/types'
import { Options, Vue } from 'vue-class-component'
import { Emit, Prop, PropSync, Watch } from 'vue-property-decorator'

// Mixins
@Options({
  components: {
    name: 'ImageViewDialog',
  },
  emits: ['update:modelValue', 'update:imageDialogVisible'],
})
export default class ImageViewDialog extends Vue {
  @PropSync('imageDialogVisible') _imageDialogVisible!: boolean
  @Prop() readonly image: Record<string, IFile[]> = {}
  activeAccordion = ''
  imagesIndex: Record<string, number> = {}

  @Emit('update:imageDialogVisible')
  closeDialog() {
    return false
  }

  onCarouselImageChange(newVal: number) {
    if (this.imagesIndex[this.activeAccordion] !== undefined) {
      this.imagesIndex[this.activeAccordion] = newVal
    }
  }

  imageIndex(label: string) {
    return this.imagesIndex[label] + 1 || 0
  }

  created() {
    this.initImagesIndex()
  }

  @Watch('image')
  onImagePropChanged() {
    this.initImagesIndex()
  }

  initImagesIndex() {
    Object.keys(this.image).forEach((label) => {
      this.imagesIndex = {
        ...this.imagesIndex,
        [label]: 0,
      }
    })
  }

  isShowArrow(label: string) {
    return this.image[label].length > 1 ? 'always' : 'never'
  }

  get imageCarouselHeaderLabel() {
    return this.$t('barcode.pictures')
  }
}
